var map = {
	"./26-04-02-why-agents-need-x402.md": [
		628,
		628
	],
	"./26-04-05-x402-in-practice.md": [
		6364,
		364
	],
	"./26-04-11-x402-implementation-deep-dive.md": [
		1642,
		642
	],
	"./26-04-15-agent-identity-work.md": [
		7695,
		695
	],
	"./26-04-15-infrastructure-of-forgetting.md": [
		9116,
		116
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2901;
module.exports = webpackAsyncContext;